import React, { useRef } from 'react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { SuccessAlert } from '../alert/SuccessAlert';

import './style.css';
import { BASE_URL, Endpoints } from '../../constants/urls';
import axios from 'axios';
import { colorTheme } from '../../utilities/ColorTheme';
import {convertUTCDateToLocalDateStringFormat} from '../../utilities/DateTimeToLocalDateTime'

export const AddEvent = ({
  updateNotificationsList,
  setUpdateNotificationsList,
  setIsAnnoucementReload,
  handleClose,
  show,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const [topic, setTopic] = useState('');
  const [loading, setLoading] = useState(false);
  const [speaker, setSpeaker] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [startDate, setStartDate] = useState('');
  const [error, setError] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [accessToken, setAccessToken] = useState(null);

  const endDateRef = useRef(null);
  const startDateRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [displayImage, setDisplayImage] = useState(null);
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
    setDisplayImage(URL.createObjectURL(file));
  };

  useEffect(() => {
    if (updateNotificationsList !== false) {
      setTopic(updateNotificationsList.title);
      setSpeaker(updateNotificationsList.speakerName);
      setStartDate(convertUTCDateToLocalDateStringFormat(updateNotificationsList.date, true, "yyyy-MM-DDTHH:mm"));
      if (
        updateNotificationsList.imageURL != null ||
        updateNotificationsList.imageURL != ''
      ) {
        setDisplayImage(updateNotificationsList.imageURL);
        setImageUrl(updateNotificationsList.imageURL);
        // setSelectedImage(true);
      }
      setIsActive(updateNotificationsList.IsActive);
    }
  }, [updateNotificationsList]);
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      setAccessToken(token);
    } else {
      console.error('Access token not found in localStorage');
    }
  }, []);

  const focusStartDate = () => {
    if (startDateRef.current) {
      startDateRef.current.showPicker();
    }
  };
  useEffect(() => {
    return () => {
      resetForm();
    };
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'topic') {
      setTopic(value);
    } else if (name === 'speaker') {
      setSpeaker(value);
    } else if (name === 'imageurl') {
      setImageUrl(value);
    }
  };

  const handleStartDate = (e) => {
    const selectedDateTime = new Date(e.target.value);
    const currentDateTime = new Date();

    if (selectedDateTime < currentDateTime) {
      e.target.value = currentDateTime.toISOString().slice(0, 16);
      alert('The selected time cannot be in the past.');
    } else {
      setStartDate(e.target.value);
    }
  };

  const handleSubmit = async (imageUrl) => {
    try {
      const url = BASE_URL + Endpoints.CreateUpdateEvent;
      const eventData = {
        id: updateNotificationsList ? updateNotificationsList.id : 0,
        title: topic,
        date: new Date(startDate).toISOString(),
        speakerName: speaker,
        imageURL: imageUrl,
      };
      const res = await axios.post(url, eventData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setShowAlert(true);
      setUpdateNotificationsList(false);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };
  const uploadImage = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (displayImage == imageUrl || selectedImage == null) {
      handleSubmit(displayImage);
    } else {
      const formData = new FormData();
      formData.append('file', selectedImage);
      try {
        const url = BASE_URL + Endpoints.UploadImage;
        const response = await axios.post(url, formData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.status === 200) {
          handleSubmit(response.data.fileUrl);
        }
      } catch (err) {
        console.log('error', err);
      }
    }
  };
  const resetForm = () => {
    setTopic('');
    setSpeaker('');
    setStartDate('');
    setImageUrl('');
    setIsActive(false);
    // setUpdateNotificationsList(false);
  };
  return (
    <>
      <div className='sentNotifiMain'>
        <form>
          <div
            className='mb-3'
            style={{
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <label className='form-label mb-0'>Topic</label>
            <input
              type='text'
              name='topic'
              value={topic}
              onChange={handleInputChange}
              className='doctor-name-input'
              placeholder='Enter Topic'
            />
          </div>

          <div
            className='mb-3'
            style={{
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <label className='form-label mb-0'>Speaker Name</label>
            <input
              name='speaker'
              value={speaker}
              onChange={handleInputChange}
              type='text'
              className='doctor-name-input'
              placeholder='Enter Speaker Name'
            />
          </div>
          <div className='mb-3'>
            <label className='form-label mb-0'>Event Date</label>
            <input
              type='datetime-local'
              name='date'
              className='doctor-name-input'
              id='startDateInput'
              ref={startDateRef}
              defaultValue={startDate}
              onFocus={focusStartDate}
              value={startDate}
              onChange={handleStartDate}
              min={new Date().toISOString().slice(0, 16)}
            />
          </div>
          <div className='image-upload-container'>
            <label htmlFor='image-upload' className='image-upload-button'>
              <div
                style={{
                  backgroundColor: colorTheme.primaryBlue,
                  paddingRight: 6,
                  paddingLeft: 6,
                  borderRadius: 4,
                  color: 'white',
                }}
              >
                Upload Image
              </div>
            </label>
            <input
              id='image-upload'
              type='file'
              accept='image/*'
              onChange={handleImageChange}
              style={{ display: 'none' }}
            />
            {displayImage && (
              <div
                className='image-preview'
                style={{
                  position: 'relative',
                  display: 'flex',
                }}
              >
                <div
                  onClick={() => {
                    setDisplayImage(null);
                    setSelectedImage(null);
                  }}
                  style={{
                    backgroundColor: colorTheme.primaryBlue,
                    width: 30,
                    height: 30,
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    color: 'white',
                    borderRadius: 3,
                    position: 'absolute',
                    left: 0,
                  }}
                >
                  X
                </div>
                <img
                  style={{ width: '50%', height: '50%' }}
                  src={displayImage}
                  alt='Selected'
                />
              </div>
            )}
          </div>
          {/* <div
            className='mb-3'
            style={{
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <label className='form-label mb-0'>Image Url</label>
            <input
              name='imageurl'
              value={imageUrl}
              onChange={handleInputChange}
              type='text'
              className='doctor-name-input'
              placeholder='Enter Image Url'
            />
          </div> */}
          <div className='text-end'>
            <button
              disabled={topic.trim() ? false : true}
              onClick={uploadImage}
              className='reidPrimaryBtn btn'
            >
              {loading ? (
                <span
                  className='spinner-grow spinner-grow-sm mr-1 ml-1'
                  role='status'
                  aria-hidden='true'
                ></span>
              ) : updateNotificationsList !== false ? (
                'Update'
              ) : (
                'Save'
              )}
            </button>
            {/* {updateNotificationsList && (
              <button
                disabled={title.trim() ? false : true}
                onClick={resetForm}
                className='reidPrimaryBtn btn'
                style={{ marginLeft: 10 }}
              >
                Reset
              </button>
            )} */}
          </div>
        </form>
      </div>
      {showAlert && (
        <SuccessAlert
          message={
            updateNotificationsList !== false
              ? 'Event updated successfully!'
              : 'Event added successfully!'
          }
          onClose={() => {
            handleClose();
            setUpdateNotificationsList(false);
            setIsAnnoucementReload(true);
            setShowAlert(false);
          }}
        />
      )}
    </>
  );
};
